import {
  getOrdersByRestaurantByDate,
} from './queries';
import { asyncListAllAndUpdateLastItem } from 'utilities/graph';

export const getOrders = async (restaurantId, start, end, onUpdateLastItem) => {
  return asyncListAllAndUpdateLastItem(getOrdersByRestaurantByDate, {
    restaurantId,
    date: {
      between: [start, end],
    },
    filter: {
      source: { eq: 'groupPurchase' },
    },
    limit: 1000,
  }, onUpdateLastItem);
};
